import React from 'react';
import { connect } from 'react-redux';

import { isSSR } from '../../../../helpers/ssr';
import ReviewsLevelTravel from '../../components/Reviews/ReviewsLevelTravel';
import { getIsWhitelabel } from '../../store/selectors/view';

interface IReviewsList {
  showLTReviews: boolean;
}

const ReviewsList: React.FC<IReviewsList> = ({ showLTReviews }) => (
  <>{showLTReviews && <ReviewsLevelTravel />}</>
);

const mapStateToProps = (state) => ({
  showLTReviews: !getIsWhitelabel(state) || !isSSR,
});

export default connect(mapStateToProps)(React.memo(ReviewsList));
